import React from "react";
import QRCode from "react-qr-code";

const PRINT_PAGE_STYLE = `
  @page { size: A4 landscape; margin: 10mm; }
  @media print {
    body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
  }
`;

function QrCard({ qr }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "48%",
        border: "1.5px solid #222",
        borderRadius: "4px",
        overflow: "hidden",
        backgroundColor: "#fff",
        pageBreakInside: "avoid",
        minHeight: "190mm", // full page height
        justifyContent: "flex-start",
      }}
    >
      {/* Black header - Company Name */}
      <div
        style={{
          width: "100%",
          backgroundColor: "#000",
          color: "#fff",
          textAlign: "center",
          padding: "14px 0 12px",
          fontSize: "18px",
          fontWeight: 700,
          fontFamily: "Arial, sans-serif",
          letterSpacing: "0.5px",
        }}
      >
        {qr.companyName || ""}
      </div>

      {/* Client Name */}
      <div
        style={{
          fontFamily: "Arial, sans-serif",
          fontSize: "15px",
          fontWeight: 500,
          color: "#222",
          margin: "18px 0 8px",
          textAlign: "center",
        }}
      >
        {qr.clientName || ""}
      </div>

      {/* QR Code - large */}
      <div style={{ margin: "18px 0 16px" }}>
        <QRCode value={qr.code || ""} size={220} />
      </div>

      {/* Code value */}
      <div
        style={{
          fontFamily: "Arial, sans-serif",
          fontSize: "12px",
          color: "#444",
          margin: "8px 0 4px",
          letterSpacing: "0.3px",
        }}
      >
        {qr.code || "-"}
      </div>

      {/* QR code name */}
      <div
        style={{
          fontFamily: "Arial, sans-serif",
          fontSize: "17px",
          fontWeight: 700,
          color: "#111",
          margin: "4px 0 0px 0",
          textAlign: "center",
        }}
      >
        {qr.qrCodeName || "-"}
      </div>

      <div
        style={{
          width: "100%",
          height: "130px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          margin: "12px 0 16px",
          flexShrink: 0,
        }}
      >
        {qr.companyLogo && (
          <img
            src={qr.companyLogo}
            alt="logo"
            style={{
              maxWidth: "180px",
              maxHeight: "120px",
              width: "auto",
              height: "auto",
              objectFit: "contain",
              display: "block",
            }}
          />
        )}
      </div>
    </div>
  );
}

const PrintableClientQrCodes = React.forwardRef(({ clientName, qrCodes }, ref) => {
  const pairs = [];
  for (let i = 0; i < (qrCodes || []).length; i += 2) {
    pairs.push((qrCodes || []).slice(i, i + 2));
  }

  return (
    <div ref={ref} style={{ backgroundColor: "#fff" }}>
      <style>{PRINT_PAGE_STYLE}</style>

      {pairs.map((pair, pageIdx) => (
        <div
          key={pageIdx}
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "stretch",
            gap: "16px",
            pageBreakAfter: pageIdx < pairs.length - 1 ? "always" : "auto",
            minHeight: "190mm",
          }}
        >
          {pair.map((qr) => (
            <QrCard key={qr.id || qr.code} qr={qr} />
          ))}
          {pair.length === 1 && <div style={{ width: "48%" }} />}
        </div>
      ))}
    </div>
  );
});

export default PrintableClientQrCodes;